import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import ExternalLink from 'components/generic/ExternalLink.component';
import LINK from 'constants/link.const';
import { useNcobRedirectUrl } from 'hooks/useNcobRedirectUrl.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useNcobSettings } from 'providers/NcobSettings.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import linkTo from 'utils/links/linkTo.util';
import asObject from 'utils/objects/asObject.util';

import CN from './OnlineBookingMenu.module.scss';

const MENU_ITEMS = [
  { key: 'general', label: 'onlineBooking.sideMenu.general', icon: 'booking', link: LINK.salonOnline, exact: true },
  { key: 'branding', label: 'onlineBooking.sideMenu.branding', icon: 'branding', link: LINK.salonOnlineBranding },
  { key: 'timings', label: 'onlineBooking.sideMenu.timings', icon: 'timing', link: LINK.salonOnlineTimings },
  { key: 'policy', label: 'onlineBooking.sideMenu.policy', icon: 'policy', link: LINK.salonOnlinePolicy },
  {
    key: 'notifications',
    label: 'onlineBooking.sideMenu.notifications',
    icon: 'text',
    link: LINK.salonOnlineTextAlerts,
  },
  { key: 'vouchers', label: 'onlineBooking.sideMenu.vouchers', icon: 'voucher', link: LINK.salonOnlineEvouchers },
];

const OnlineBookingMenu = () => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  const { value } = useNcobSettings();
  const { ncobTinyUrl } = asObject(value);
  const effectiveBookingUrl = useNcobRedirectUrl({ ncobTinyUrl, salonId });

  const componentClasses = cn({
    [CN.component]: true,
    [CN.darkMode]: isDarkMode,
  });

  return (
    <div data-bem="OnlineBookingMenu" className={componentClasses}>
      <div className={CN.container}>
        {MENU_ITEMS.map(({ key, label, icon, link }) => (
          <NavLink key={key} className={CN.menuItem} activeClassName={CN.selected} to={linkTo({ pattern: link, params: { salonId }, fault: '#' })}>
            <div className={CN[icon]} />
            {t(label)}
          </NavLink>
        ))}
        {effectiveBookingUrl && (
          <div className={CN.linkContainer}>
            <Button variant="primary" onClick={alwaysNoop}>
              <ExternalLink link={effectiveBookingUrl}>
                <div className={CN.link}>{t('onlineBooking.sideMenu.testBooking')}</div>
              </ExternalLink>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default OnlineBookingMenu;
